export const ownerCodeKeys = [
  {
    name: "Code",
    key: "name",
  },
  {
    name: "Description",
    key: "description",
  },
];
